export const PATH = {
  login: "/login",
  applock: "/applock",
  redirect: "/oauth/kakao",
  redirect_apple: "/oauth/apple",
  onboarding: "/onboarding/:id",
  onboarding_new: "/onboarding_new/:type/:id",
  etc_where: "/onboarding_new/etc_where",

  home: "/:taskKey?",
  payment: "/payment",
  paymentV2: "/v2/payment",

  tossPayments: "/toss-payments",
  tossPaymentsSuccess: "/toss-payments/success",
  tossPaymentsFail: "/toss-payments/fail",

  newsletterSettings: "/newsletter/settings",

  selfCheck: "/self-check/:tool/:id",
  selfCheckEnd: "/self-check/:tool/end",

  institutionSelect: "/institution-select",
  emailAuth: "/email-auth",
  emailAuthResult: "email-auth/result",

  meditationTool: "/meditation",
  guide: "/guide/:id",
  promotion: "/promotion/:type",
  account: "/mypage/account",
  support: "/support/faq",
  supportDetail: "/support/faq/detail",
  promotionPhoneNumberSubmit: "/benefit-apply",
  test: "/test",
};
